import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ContainerComponent } from '@oneqrew-partnertool/container';
import { selectPlan, selectFetchedPlans } from '@oneqrew-partnertool/core';
import { distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';
import { Plan } from '@oneqrew-partnertool/models';
import { PlanSelectorComponent } from '@oneqrew-partnertool/plan-selector';
import { NewPlanSelectorComponent } from '@oneqrew-partnertool/new-plan-selector';
import { SharedModule, SUBCRIPTION_PLANS } from '@oneqrew-partnertool/utils';
import { combineLatest, Observable } from 'rxjs';
import * as textData from '../../../../../shared-assets/data/pages/front-page.json';

@Component({
  selector: 'lib-subscription-plans',
  standalone: true,
  imports: [SharedModule, ContainerComponent, PlanSelectorComponent, NewPlanSelectorComponent],
  templateUrl: './subscription-plans.component.html',
  styleUrls: ['./subscription-plans.component.scss']
})
export class SubscriptionPlansComponent implements OnInit {
  @Input() isNewCustomerPlan: boolean = false;
  class = 'subscription-plans';
  plans: Plan[] = [];
  plan$!: Observable<Plan>;
  textData = textData;

  isDragging = false;
  startX = 0;
  scrollLeft = 0;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.plan$ = this.store.select(selectPlan);
    const fetchedPlans$ = this.store.select(selectFetchedPlans).pipe(take(1));

    // Hide S packet on old customers app
    // Hide selected on new customers app
    const plans$ = this.isNewCustomerPlan
      ? combineLatest([fetchedPlans$, this.plan$]).pipe(
          map(([fetchPlans, selectedPlan]: [Plan[], Plan]) => {
            return fetchPlans.filter((p) => p.packageType != selectedPlan.packageType);
          })
        )
      : fetchedPlans$.pipe(
          map((plans) => {
            return plans.filter((plan) => plan.packageType != SUBCRIPTION_PLANS.S_PAKET.packageType);
          })
        );

    // add startDate info on other plans, needed for determining the discount (legacy discount)
    this.plan$.pipe(distinctUntilChanged()).subscribe((plan) => {
      this.plans = this.plans.map((p) => ({ ...p, startDate: plan.startDate }));
    });

    plans$.subscribe((fetchedPlans: Plan[]) => {
      if (!fetchedPlans || fetchedPlans.length === 0) {
        console.warn('Fetched Plans are empty. Ensure the store is updated before this component initializes.');
      } else {
        this.plans = fetchedPlans;
      }
    });
  }

  startDrag(event: MouseEvent): void {
    const container = (event.target as HTMLElement).closest('.scrollable') as HTMLElement;
    if (container) {
      this.isDragging = true;
      this.startX = event.pageX - container.offsetLeft;
      this.scrollLeft = container.scrollLeft;
      container.classList.add('dragging');
    }
  }

  onDrag(event: MouseEvent): void {
    if (!this.isDragging) return;
    const container = (event.target as HTMLElement).closest('.scrollable') as HTMLElement;
    if (container) {
      event.preventDefault();
      const x = event.pageX - container.offsetLeft;
      const walk = (x - this.startX) * 1.5; // drag speed
      container.scrollLeft = this.scrollLeft - walk;
    }
  }

  stopDrag(): void {
    this.isDragging = false;
    const containers = document.querySelectorAll('.scrollable.dragging');
    containers.forEach((container) => container.classList.remove('dragging'));
  }
}
